import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ShieldCheck } from "lucide-react";

/**
 * Shared shell for the legal pages, so Privacy / Cookies / Terms all share
 * the same dark-luxury layout, rhythm, and CTA tail without each repeating it.
 */
export default function LegalLayout({
  eyebrow,
  title,
  intro,
  lastUpdated,
  children,
  testid,
}) {
  return (
    <div className="pt-32 sm:pt-40 pb-24" data-testid={testid}>
      <section className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3">
          <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl border border-gold/30 bg-gold/[0.06] text-gold">
            <ShieldCheck className="w-[18px] h-[18px]" />
          </span>
          <span className="eyebrow text-gold">{eyebrow}</span>
        </div>
        <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-[58px] leading-[1.05] tracking-tight text-mute-100">
          {title}
        </h1>
        {intro && (
          <p className="mt-6 text-[17px] leading-[1.7] text-mute-200 max-w-3xl">
            {intro}
          </p>
        )}
        {lastUpdated && (
          <p className="mt-6 text-[12px] uppercase tracking-[0.22em] text-mute-300">
            Last updated · {lastUpdated}
          </p>
        )}
      </section>

      <section className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 mt-14 legal-prose">
        {children}
      </section>

      <section className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 mt-20">
        <aside className="relative rounded-3xl glass-strong overflow-hidden p-8 sm:p-10">
          <div
            className="absolute -top-24 -right-20 w-[400px] h-[400px] rounded-full pointer-events-none"
            style={{
              background:
                "radial-gradient(closest-side, rgba(199,166,106,0.12), transparent 70%)",
            }}
          />
          <div className="relative grid grid-cols-1 sm:grid-cols-2 gap-5 items-center">
            <div>
              <div className="text-[10.5px] uppercase tracking-[0.22em] text-gold">
                Questions
              </div>
              <p className="mt-3 text-[15px] leading-[1.7] text-mute-200 max-w-md">
                If you would like to discuss any of the above, please contact us at{" "}
                <a
                  href="mailto:contact@linked2marketing.com"
                  className="text-gold hover:underline"
                >
                  contact@linked2marketing.com
                </a>
                .
              </p>
            </div>
            <div className="sm:justify-self-end">
              <Link to="/#enquiry" className="btn-primary">
                Start a conversation <ArrowUpRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </aside>
      </section>
    </div>
  );
}
